'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Typography from '@egalite/ui/Typography';
import ButtonsPages from './legacy_blocks/ButtonsPages';
import CheckboxGroup from '@egalite/ui/Form/CheckboxGroup';
import useForm from '../../lib/hooks/useForm';
import validationSchema, { initialValues } from '../../lib/validation/candidate/professionalData2';
import { useState, useEffect, useRef, useCallback, FC } from 'react';
import Loading from '@egalite/ui/Loading';
import save from './save';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import authFetch from '../../lib/auth/authFetch';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import FormPage from './legacy_blocks/CandidateFormPage';
import Button from '@egalite/ui/Buttons';

const ProfessionalData2Form: FC<{edit?: boolean, onSuccess?: () => void}> = ({ edit = false, onSuccess = null }) => {
	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState(initialValues);

	const router = useRouter();

	const [formController, getFieldProps, { loading, submitting, success, errors, data }] = useForm({
		initialValues: candidateData,
		validationSchema,
		mutation: data => save('/api/v1/candidate/professionalData2', data),
		onSuccess: onSuccess != null ? () => onSuccess() : () => {
			router.push(`/candidato/form/professionalDataEducationIndex`, {scroll: true});
		},
	});
	useEffect(() => {
		if (loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					if (data.success === true) {
						const newValues = Object.keys(initialValues).reduce((acc, key) => {
							acc[key] = data.data[key] ?? initialValues[key];
							return acc;
						}, {});
						setCandidateData(newValues as typeof initialValues);
						setLoadingData(false);
					} else {
						notification.error('Erro ao carregar dados do candidato');
					}
				});
		}
	}, [formController, router, loadingData, notification]);

	if (loadingData) {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}

	return (
		<FormPage
			actualStep={3}
			formActualStep={2}
			formTotalSteps={5}
			progress={40}
			formTitle={'Dados profissionais'}
			// previousForm="/"
			showStepsMenu={false}
			// showBackButton={false}
			modal={edit}
		>
			<form onSubmit={formController.handleSubmit}>
				<div className="mb-16 md:mb-24">

					<Typography variant="headline-5" className="text-brand-main mb-4" >
						Área de interesse
					</Typography>


					<Typography variant="body2" className="text-base mb-10" component="h6" >
						Selecione até 3 áreas que você tem interesse em trabalhar para buscarmos as melhores oportunidades para você.
					</Typography>

					<CheckboxGroup
						max={3}

						options={[
							'Administrativo',
							'Almoxarifado',
							'Atendimento',
							'Auditoria',
							'Call center',
							'Comercial',
							'Compliance',
							'Compras',
							'Construção',
							'Fiscal',
							'Alimentação',
							'Educação',
							'Elétrica/eletrônica',
							'Engenharia',
							'Financeiro',
							'Indústria',
							'Jurídico',
							'Logística',
							'Manutenção',
							'Marketing',
							'Produção',
							'Qualidade',
							'Recursos Humanos',
							'Saúde',
							'Segurança do trabalho',
							'Serviços gerais',
							'Tecnologia (TI)',
							'Portaria/Segurança',
						]
							.sort((a, b) => (a < b ? -1 : 1))}
						descriptionFieldProps={{
							option: 'Outro',
							...getFieldProps('sectorOtherDescription'),
						}}
						{...getFieldProps({ name: 'sector', type: 'checkbox' })}
					/>

					{/* <ErrorList errors={formController.errors} touched={formController.touched} /> */}
					{Array.isArray(errors) &&
						errors.map((err, index) => (
							<Typography key={`err-${index}`} variant="body2" color="error.dark">
								{err}
							</Typography>
						))}

					<div className='md:mt-24 mt-16'>
						{edit ?
							<Button type='submit' variant='primary' className='w-full'>Salvar</Button>
							: 
							<ButtonsPages previousForm={'/candidato/form/professionalData1'} hideBack={edit} />
						}
					</div>
				</div>
			</form>
		</FormPage>
	);
}


export default ProfessionalData2Form;